module.exports = __webpack_public_path__ + "static/media/bg.4afbd902.png";